(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toads-track"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const forms = document.querySelectorAll('[data-toads-track]');
    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        const input = form.querySelector('input[name="awb"]');
        const error = form.querySelector('[data-toads-track-error]');
        const base = form.getAttribute('data-track-base') || '';
        const value = (input && input.value ? input.value : '').trim().replace(/\s+/g, '');

        if (!value || !base) {
          if (error) error.hidden = false;
          if (input) input.focus();
          return;
        }

        if (error) error.hidden = true;
        const url = base.indexOf('{awb}') > -1
          ? base.replace('{awb}', encodeURIComponent(value))
          : base.replace(/\/+$/, '') + '/' + encodeURIComponent(value);

        window.open(url, '_blank', 'noopener');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
